// Libraries
import { Dialog, DialogContent, IconButton, Stack } from "@mui/material";

// Utils
import {
	getNewKiosks,
	getUniqueSaleKiosks,
	isThereAnyNewSwitchBetweenSides,
	splitKiosksByType,
} from "@/Settings/helpers/AdministrationTools/DealerAdministrationTools/KeyManagementSystem";
import { TSwitchableItem } from "@/Settings/types/administrationTools/utils";

// Types
import { IKmsStore } from "@/Settings/types/administrationTools/model";

// Icons
import CloseRoundedIcon from "@mui/icons-material/CloseRounded";

// Components
import SwitchableLists from "@/Layouts/components/InputComponents/SwitchableLists";
import CustomButton from "@/Layouts/components/Buttons/Button";
import { useState } from "react";

type TDialogSwitchableKiosksProps = {
	open: boolean;
	kmsStores: IKmsStore[];
	setOpen: (value: boolean) => void;
	onChange: (values: IKmsStore[]) => void;
};

export default function DialogSwitchableKiosks(props: Readonly<TDialogSwitchableKiosksProps>) {
	const { open, kmsStores, setOpen, onChange } = props;

	const { saleKiosks, serviceKiosks } = splitKiosksByType(kmsStores);

	const [leftSide, setLeftSide] = useState<TSwitchableItem[]>(saleKiosks);
	const [rightSide, setRightSide] = useState<TSwitchableItem[]>(serviceKiosks);

	function handleOnAssign() {
		setOpen(false);

		const kmsStoresWithSplitKiosks: IKmsStore[] = kmsStores.map((store) => {
			const { id: storeId, saleKiosks: oldSaleKiosks } = store;

			const newServiceKiosks = getNewKiosks(rightSide, storeId);
			const newSaleKiosks = getNewKiosks(leftSide, storeId, true);
			const uniqueNewSaleKiosks = getUniqueSaleKiosks(newSaleKiosks, oldSaleKiosks, newServiceKiosks);

			return { ...store, serviceKiosks: newServiceKiosks, saleKiosks: uniqueNewSaleKiosks };
		});

		isThereAnyNewSwitchBetweenSides({ saleKiosks, serviceKiosks }, { saleKiosks: leftSide, serviceKiosks: rightSide }) &&
			onChange(kmsStoresWithSplitKiosks);
	}

	return (
		<Dialog
			disableEscapeKeyDown
			fullWidth
			PaperProps={{
				className: "!rounded-[10px] !max-w-[684px]",
			}}
			open={open}
			onClose={() => handleOnAssign()}
		>
			<DialogContent className="!p-8 relative">
				<IconButton aria-label="close" className="!absolute !text-disabled right-0 top-0 !p-3" onClick={() => handleOnAssign()}>
					<CloseRoundedIcon />
				</IconButton>

				<SwitchableLists<TSwitchableItem>
					key={"switchable-lists-sale-service-kiosks"}
					showBy={"label"}
					sortBy={"label"}
					sections={{
						left: {
							title: "Sales",
							items: leftSide,
							setItems: setLeftSide,
						},
						right: {
							title: "Service",
							items: rightSide,
							setItems: setRightSide,
						},
					}}
				/>
				<Stack direction={"row"} justifyContent={"flex-end"}>
					<CustomButton
						variant="contained"
						text={"Assign"}
						classes="tier-btn !bg-primary hover:!shadow-primary-shadow-50 h-[30px] !w-[82px] !rounded-[6px] btn-regular-text"
						bgColor={"var(--primary-color)"}
						onClick={() => handleOnAssign()}
						sx={{ textTransform: "unset !important" }}
					/>
				</Stack>
			</DialogContent>
		</Dialog>
	);
}
